module.exports = __webpack_public_path__ + "img/Amcare.7d4ce15d.jpg";